
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cph-to-copenhagen",
      function () {
        return require("private-next-pages/cph-to-copenhagen.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cph-to-copenhagen"])
      });
    }
  